import React from "react";
import { Link } from "react-router-dom";
import { PlayIcon } from "./Icon";
import MarqueeSection from "./MarqueeSection";

const Banner = () => {
	return (
		<section
			className="banner-section"
			style={{
				background: `url('/img/banner-bg.png') no-repeat center center / cover`,
			}}
		>
			<MarqueeSection />
			<div className="container">
				<div className="banner-wrapper">
					<div className="banner-content">
						<span className="banner-badge">
							<strong className="me-2"></strong>
							<span style={{ color: "#A5DA2E" }}>
								MAINNET
							</span>
						</span>
						<h1 className="title">
							Alpha <div className="text-gradient">Launchpad</div> on solana
						</h1>
						<div className="txt poppins">
							Launch your Token sale on our launchpad {" "}
						</div>
						<div className="btn-group">
							<Link className="btn-base" to="https://solrocket.fillout.com/t/geZ9pQHAPvus?solrocket=xxxxx
">
								List a Project
							</Link>
							<Link className="video-btn" to="/launchpad-list">
								<PlayIcon /> Explore more
							</Link>
						</div>
					</div>
					<div className="banner-thumb">
						<img src="/img/banner.png" alt="" />
					</div>
				</div>
			</div>
		</section>
	);
};

export default Banner;
